import React from 'react'
import StockListado from '../../../models/stock/stock_listado'
import CartaDePorteVetada from '../../../models/cartaDePorte/carta_de_porte_vetada'
import DetalleCartasDePorteVetadaDialog from '../containers/DetalleCartasDePorteVetadaDialog'
import { TABLE_CARTAS_DE_PORTE_VETADAS, DETALLE_TABLE_CARTAS_DE_PORTE_VETADAS } from '../../../config/tables'
import { toast } from 'react-toastify'
import { obtenerVersionLaridae } from '../../Utils/actions'

export function obtenerCartasDePorteVetadas () {
  return (dispatch, getState) => {
    return CartaDePorteVetada.getCartasDePorte()
      .then((data) => dispatch({
        type: 'TOTAL_CARTA_DE_PORTE_VETADA',
        data
      },
      toast.info('Cartas de porte vetadas actualizadas.')))
  }
};

export function obtenerDetalleCartaDePorteVetada (callback) {
  return (dispatch, getState) => {
    const state = getState()
    const detalle = state.stock.detalle
    const {
      fechaDesde,
      fechaHasta
    } = state.stock
    const {
      cereal,
      exportador
    } = detalle
    const stockListado = new StockListado()
    return stockListado.getMercaderiaFumigada(fechaDesde, fechaHasta, exportador, cereal)
      .then((data) => {
        dispatch({
          type: 'DETALLE_CARTA_DE_PORTE_VETADA',
          data: data.data
        })
      },
      callback && callback())
  }
};

export function actualizarFecha (fecha) {
  return (dispatch, getState) => dispatch({
    type: 'ACTUALIZAR_FECHA_CONSULTA_STOCK',
    fecha
  })
};

export function actualizarVersion () {
  return (dispatch, getState) => {
    dispatch(obtenerVersionLaridae())
  }
}

export function updateTablaDeCartasDePorteVetadas (newState) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState,
      id: TABLE_CARTAS_DE_PORTE_VETADAS
    })
  }
}

export function updateTablaDeCartasDePorteVetadasDetalle (newState) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState,
      id: DETALLE_TABLE_CARTAS_DE_PORTE_VETADAS
    })
  }
}

export function actualizarDetalles (detalle) {
  return (dispatch, getState) => {
    dispatch({
      type: 'ACTUALIZAR_DETALLES',
      detalle: detalle
    })
  }
}

export function descargarDetallesPDF () {
  return (dispatch, getState) => {
    dispatch({
      type: 'GENERAR_DETALLE_PDF',
      fileDetallePdfOk: true
    })
  }
}

export function saveDetallePdf () {
  return (dispatch, getState) => {
    dispatch({
      type: 'GENERAR_DETALLE_PDF',
      fileDetallePdfOk: false
    })
    dispatch({
      type: 'DETALLE_CARTA_DE_PORTE_VETADA',
      data: null
    })
  }
}

export function saveAllPdf () {
  return (dispatch, getState) => {
    dispatch({
      type: 'GENERAR_PDF',
      fileOk: false
    })
  }
}

export function openDialogDetalles (detalle) {
  return (dispatch, getState) => {
    dispatch({
      type: 'ACTUALIZAR_DETALLES',
      detalle: detalle
    })
    const confirmCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'DETALLE_CARTAS_DE_PORTE_VETADAS_DIALOG'
      })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'DETALLE_CARTAS_DE_PORTE_VETADAS_DIALOG',
      title: 'Detalle de Carta de Porte',
      maxWidth: 'md',
      showPrint: true,
      content: <DetalleCartasDePorteVetadaDialog />,
      confirmCallback: confirmCallback
    })
  }
}
